import { DiscordDetails } from '../../../queries/types';

export const getUserDiscordDetailsModelCreator = (
  response: DiscordDetails
): DiscordDetails => response;
